








/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop } from "vue-property-decorator";
import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";
import { User } from "../interfaces/user";
import { SubscriptionService } from "../services/subscriptionService";
import { AuthService } from "../services/authService";

declare global {
    interface Window {
        paypal: {
            Buttons(x: {
                createSubscription: Function;
                onApprove: Function;
                onError: Function;
            }): { render: Function };
        };
    }
}

@Component({ components: { HomeFooter, HomeHeader } })
export default class PaypalCheckout extends Vue {
    @Prop() public articleId?: string;
    @Prop() public clientId?: string;

    public loaded = false;
    public paidFor = false;

    public mounted() {
        const script = document.createElement("script");
        // https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-configuration/
        const options: string[] = [
            `client-id=${this.clientId}`,
            "currency=EUR",
            `locale=${this.$t("localeName")}`,
            "vault=true",
            "intent=subscription",
        ];
        script.src = `https://www.paypal.com/sdk/js?${options.join("&")}`;
        script.addEventListener("load", this.setLoaded);
        document.body.appendChild(script);
    }
    public get user(): User | null {
        return this.$store.state.user;
    }
    public setLoaded() {
        this.loaded = true;
        window.paypal
            .Buttons({
                createSubscription: this.createSubscription,

                onApprove: this.onApprove,
                onError: this.onError,
            })
            .render(this.$refs.paypal);
    }
    public async onApprove(data: { subscriptionID: string; orderID: string }) {
        this.paidFor = true;
        const token = await this.$auth.getTokenSilently();
        await SubscriptionService.createSubscription(
            { id: data.subscriptionID, orderID: data.orderID },
            token
        );
        const user = await AuthService.getUser(token);
        this.$store.commit("setUser", { user });
    }
    public onError(err: string) {
        console.log(err);
    }
    public createSubscription(
        data: {},
        actions: { subscription: { create(args: { plan_id: string }): {} } }
    ) {
        return actions.subscription.create({
            plan_id: this.articleId || "",
        });
    }
}
